export default function setDefaultHeaders({
  headers,
}: {
  // Explicitly undefined-able: under exactOptionalPropertyTypes an optional
  // property is NOT implicitly undefined-able at a call site, and every
  // caller here passes a value that may legitimately be undefined.
  headers?: Record<string, string> | undefined;
}): Record<string, string> {
  const cleanHeaders: Record<string, string> = {};
  for (const [name, value] of Object.entries(headers ?? {})) {
    cleanHeaders[name.toLowerCase()] = value;
  }
  cleanHeaders.accept ||= "application/json";
  cleanHeaders["content-type"] ||= "application/json";
  return cleanHeaders;
}
